<template>
  <div class="item-wrap">
    <div class="item-rank">{{ rank }}</div>
    <div class="item-content">
      <p class="title">
        <span style="font-size: 13px">{{ storeItem.name }}</span>
        <span>
          <span :style="{ color: color }">{{
            storeItem.showText
              ? storeItem.showText
              : (storeItem.nowScore || 0).toFixed(2)
          }}</span>
          <span style="color: #fbcda7" v-if="storeItem.beforeScore"
            >/{{ (storeItem.beforeScore || 0).toFixed(2) }}</span
          >
        </span>
      </p>
      <Progress
        :stroke-color="color"
        class="first-line"
        :percent="storeItem.nowScore"
        :stroke-width="3"
        text-inside
      />
      <Progress
        v-if="storeItem.beforeScore"
        stroke-color="#FBCDA7"
        class="second-line"
        :percent="storeItem.beforeScore"
        :stroke-width="3"
        text-inside
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    storeItem: {
      type: Object,
    },
    storeIndex: {
      type: Number,
    },
    currentPage: {
      type: Number,
    },
    color: {
      type: String,
      default: '#FBA155',
    },
  },
  computed: {
    rank() {
      return this.storeIndex + 1 + (this.currentPage - 1) * 5;
    },
  },
};
</script>

<style lang="less" scoped>
.item-wrap {
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  height: 40px;
  //   background-color: #bfa;
  //   overflow: hidden;
  position: relative;
  .item-rank {
    font-size: 12px;
    font-weight: 600;
    display: inline-block;
    width: 22px;
    height: 22px;
    line-height: 22px;
    border-radius: 6px;
    background: #f0f0f0;
    color: #333333;
    text-align: center;
    position: absolute;
    bottom: 0px;
  }
  .item-content {
    position: absolute;
    height: 40px;
    left: 40px;
    display: inline-block;
    width: calc(100% - 10px);
    // width: 100%;
    .title {
      position: relative;
      top: 14px;
      display: flex;
      justify-content: space-between;
    }
    .first-line {
      ::v-deep {
        .ivu-progress-inner {
          top: 2px;
        }
      }
    }
    .second-line {
      ::v-deep {
        .ivu-progress-inner {
          top: -16px;
        }
      }
    }
  }
}
</style>
